import React, { FC, isValidElement } from "react";
import TableCell from "@material-ui/core/TableCell";
import { Header, LabelProps } from "Components/DP/DPTable/DPTable";

type Props = {
  header: Header;
};

const DPTableHeaderCell: FC<Props> = ({ header }) => {
  if (isValidElement(header)) return header;
  if (typeof header === "string") {
    header = { label: header, align: "left" };
  }
  header = header as LabelProps;
  return (
    <TableCell
      key={header.label}
      align={header.align}
    >
      {header.label}
    </TableCell>
  );
};

export default DPTableHeaderCell;
